// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"94cd568e","383":"7041be22","453":"bfd9525f","700":"c8cfab9f"}[chunkId] + ".chunk.js";
};